import { render, staticRenderFns } from "./ASINsCompare.vue?vue&type=template&id=fb432c96&scoped=true"
import script from "./ASINsCompare.vue?vue&type=script&lang=js"
export * from "./ASINsCompare.vue?vue&type=script&lang=js"
import style0 from "./ASINsCompare.vue?vue&type=style&index=0&id=fb432c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb432c96",
  null
  
)

export default component.exports